import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { Button, Stack } from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MessageLayout from '../component/layout/MessageLayout';

const IncompleteProfilePage: React.FC = () => {
  const navigate = useNavigate();

  const { t } = useTranslation('errorModule');

  const handleRedirect = useCallback(async () => {
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url: `${import.meta.env.VITE_REGISTRATION_URL}/complete/resume` });
    } else {
      window.location.href = `${import.meta.env.VITE_REGISTRATION_URL}/complete/resume`;
    }
  }, []);

  const handleLogout = useCallback(() => {
    navigate('/logout', { replace: true });
  }, [navigate]);

  return (
    <MessageLayout
      title={t('incompleteProfile.header')}
      text={t('incompleteProfile.text')}
      actions={
        <Stack spacing={1} justifySelf="center" width="80%">
          <Button variant="contained" color="primary" onClick={handleRedirect}>
            {t('incompleteProfile.button')}
          </Button>
          <Button variant="contained" color="secondary" onClick={handleLogout}>
            {t('logout')}
          </Button>
        </Stack>
      }
    />
  );
};

export default IncompleteProfilePage;
